import { Controller } from "@hotwired/stimulus";

// The badge lives in the card header and the scrim in the card body, so it reaches the overlay through an
// outlet scoped to this card rather than by walking the DOM. Toggles, so the badge both opens a dismissed
// scrim and closes it again.
export default class extends Controller {
  static outlets = ["admin--report--dismiss-filter-overlay"];

  toggle() {
    this.adminReportDismissFilterOverlayOutlets.forEach((overlay) =>
      overlay.toggle(),
    );
  }
}
